module.exports = __webpack_public_path__ + "static/media/logo_vrb.86b951bb.svg";